import PropTypes from 'prop-types';

import Pagination from 'common/components/Pagination';
import { transactionPropTypes, runPropTypes } from 'common/propTypes';

const propTypes = {
  transactions: PropTypes.arrayOf(transactionPropTypes).isRequired,
  currentPageIndex: PropTypes.number.isRequired,
  transactionsPerPage: PropTypes.number.isRequired,
  onCurrentPageChange: PropTypes.func.isRequired,
  run: runPropTypes.isRequired,
  deployLiveRun: PropTypes.element,
};
const defaultProps = {
  deployLiveRun: null,
};

const TransactionsFooter = (props) => {
  const {
    transactions, currentPageIndex, transactionsPerPage, onCurrentPageChange, deployLiveRun
  } = props;
  const totalTransactions = transactions.length;
  const totalPages = totalTransactions / transactionsPerPage;
  const startOfRange = transactionsPerPage * currentPageIndex;
  const endOfRange = startOfRange + transactionsPerPage < totalTransactions
    ? startOfRange + transactionsPerPage
    : totalTransactions;

  return (
    <div className="transactions-footer">
      <div className="count-show align-self-center">
        {`Showing ${startOfRange + 1} to ${endOfRange} of ${totalTransactions} entries`}
      </div>

      <div className="d-flex align-items-center gap-5">
        {deployLiveRun && deployLiveRun}
        {totalTransactions > transactionsPerPage && (
          <Pagination
            totalPages={totalPages}
            onPageChange={({ selected: selectedPage }) => onCurrentPageChange(selectedPage)}
            currentPageIndex={currentPageIndex}
          />
        )}
      </div>
    </div>
  );
};

TransactionsFooter.propTypes = propTypes;
TransactionsFooter.defaultProps = defaultProps;
export default TransactionsFooter;
